import { StatusChip } from "components/StatusChip";

import {
  type DiscrepancyStatus,
  getStatusColor,
  getStatusLabel,
} from "./DiscrepancyReviewDialog.helpers";

/**
 * A finding's status, in every Status column and in the compliance actions row.
 *
 * The shared `StatusChip`'s `soft` variant: the role's colour at 8% behind a
 * label in that colour, no border, per the design-system chip spec. Colours
 * come from `getStatusColor` — warning for unresolved, info for pending,
 * success for resolved, and the neutral grey role for ignored.
 *
 * One component for all five sites: the four panes printed the label as plain
 * text, and the compliance actions row had its own outlined chip on a white
 * fill.
 */
export function DiscrepancyStatusChip({
  status,
  icon,
}: {
  status: DiscrepancyStatus;
  /** Marks a resolution that differs from the usual one, e.g. never in e-Manifest. */
  icon?: React.ReactElement;
}) {
  return <StatusChip color={getStatusColor(status)} label={getStatusLabel(status)} icon={icon} />;
}
